<script setup>
import { computed } from 'vue';

const props = defineProps({
  variant: {
    type: String,
    default: 'default'
  }
});

const classes = computed(() => {
  return {
    default:
      'text-default bg-default/10 dark:bg-pill-default dark:text-pill-default-content',
    success:
      'text-success bg-success/10 dark:bg-pill-success dark:text-pill-success-content',
    warning:
      'text-warning bg-warning/10 dark:bg-pill-warning dark:text-pill-warning-content',
    danger:
      'text-danger bg-danger/10 dark:bg-pill-danger dark:text-pill-danger-content',
    info: 'text-info bg-info/10 dark:bg-pill-info dark:text-pill-info-content'
  }[props.variant];
});
</script>

<template>
  <div
    class="pill inline-block rounded px-3 py-1 text-center text-xs"
    :class="classes"
    style="text-wrap: nowrap"
  >
    <slot />
  </div>
</template>
